import React from "react";
import { useQuery } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_TREATMENT_PLANTS } from "../../../queries/archiveQrys/InventoryReportQueries";
import { binStatus } from "../../../utilities/constants/BinStatusConstants";
import { waterSystemStatus } from "../../../utilities/constants/WaterSystemConstants";
//import { convertTimeStampToDate } from "../../../utilities/commonFunctions/formattingFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const TreatmentPlantsTable = (props) => {
  const { systemId } = props;

  const treatmentPlantColumns = [
    {
      Header: () => null,
      id: "expander",
      width: 30,
      Cell: ({ row }) => (
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <FontAwesomeIcon
              className="font-icon"
              icon={faCaretDown}
              cypressid={row.original.treatmentPlantId + "_tpd"}
            />
          ) : (
            <FontAwesomeIcon
              className="font-icon"
              icon={faCaretRight}
              cypressid={row.original.treatmentPlantId + "_tpr"}
            />
          )}
        </span>
      )
    },
    {
      Header: "ID",
      accessor: "treatmentPlantId",

      width: 75
    },
    {
      Header: "Plant Name",
      accessor: "plantName",

      width: 200
    },
    {
      Header: "Bin",
      accessor: "binType",

      width: 75
    },
    {
      Header: "Bin Status",
      accessor: (d) => {
        return d.binStatus ? binStatus[d.binStatus] : "";
      }
    },
    {
      Header: "Date",
      id: "binDate",
      /*accessor: (d) => {
        return d.binDate ? convertTimeStampToDate(d.binDate) : "";
      }*/
      accessor: "binDate"
    },
    {
      Header: "Design Cap",
      accessor: "designCap"
    },
    {
      Header: "Status",
      accessor: (d) => {
        return d.status ? waterSystemStatus[d.status] : "";
      }
    }
  ];

  const purposeColumns = React.useMemo(
    () => [
      {
        Header: "Purpose",
        accessor: "purpose"
      }
    ],
    []
  );

  const { loading, error, data } = useQuery(GET_TREATMENT_PLANTS, { variables: { systemId } });

  const subTable = React.useCallback(
    ({ row }) =>
      row.original.treatmentPurpose.length > 0 ? (
        <DtsReactTable columns={purposeColumns} data={row.original.treatmentPurpose} headerColor="grey" cypressid="treatmentPlantsTable"/>
      ) : (
        "No Data"
      ),
    [purposeColumns]
  );

  const expandedRows = React.useMemo(() => {
    if (data) {
      let arr;
      let d = data;
      if (d.getInventoryTreatmentPlantsBySystemId.length > 0) {
        arr = d.getInventoryTreatmentPlantsBySystemId.map((sid, ind) => {
          return { [ind]: true };
        });
      }
      return arr;
    }
  }, [data]);

  if (loading) return <SkeletonLoader width="100%"/>;
  if(error) return <ErrorHandler error={error} />
  
  return (
    <>
      {data.getInventoryTreatmentPlantsBySystemId.length > 0 ? (
        <DtsReactTable
          data={data.getInventoryTreatmentPlantsBySystemId}
          columns={treatmentPlantColumns}
          headerColor="ddw"
          renderRowSubComponent={subTable}
          expandRows={true}
          expandedRowObj={expandedRows}
          subTableId={"_tpSubtable"}
        />
      ) : (
        <span>
          <em>No treatment plant information found in database.</em>
        </span>
      )}
    </>
  );
};

export default TreatmentPlantsTable;
